import { MockMethod } from 'vite-plugin-mock'
import { SUCCESS_CODE } from '@/constants'

const timeout = 1000

const freezeLogList: any[] = [
  { freezeDate: '2025-05-01 10:30:00', money: 1200.50, totalMoney: 25000.00, status: '冻结中', freezeReason: '订单确认' },
  { freezeDate: '2025-05-02 14:15:00', money: 3050.00, totalMoney: 40000.00, status: '已解冻', freezeReason: '订单确认' },
  { freezeDate: '2025-05-03 09:45:00', money: 780.20, totalMoney: 15000.00, status: '冻结中', freezeReason: '订单退款' },
  { freezeDate: '2025-05-04 18:20:00', money: 5600.00, totalMoney: 38000.00, status: '异常', freezeReason: '订单确认' },
  { freezeDate: '2025-05-05 11:10:00', money: 1300.75, totalMoney: 21000.00, status: '冻结中', freezeReason: '订单退款' },
  { freezeDate: '2025-05-06 16:40:00', money: 4000.00, totalMoney: 30000.00, status: '已解冻', freezeReason: '订单退款' },
  { freezeDate: '2025-05-07 08:50:00', money: 2500.30, totalMoney: 27000.00, status: '异常', freezeReason: '订单退款' },
  { freezeDate: '2025-05-08 15:30:00', money: 980.00, totalMoney: 19000.00, status: '冻结中', freezeReason: '订单确认' },
  { freezeDate: '2025-05-09 12:25:00', money: 4500.00, totalMoney: 32000.00, status: '已解冻', freezeReason: '订单退款' },
  { freezeDate: '2025-05-10 09:10:00', money: 3500.45, totalMoney: 35000.00, status: '冻结中', freezeReason: '订单确认' },
  { freezeDate: '2025-05-11 13:15:00', money: 2700.00, totalMoney: 28000.00, status: '异常', freezeReason: '订单退款' },
  { freezeDate: '2025-05-12 10:50:00', money: 1500.00, totalMoney: 24000.00, status: '冻结中', freezeReason: '订单确认' },
  { freezeDate: '2025-05-13 17:05:00', money: 6000.00, totalMoney: 41000.00, status: '已解冻', freezeReason: '订单退款' },
  { freezeDate: '2025-05-14 08:35:00', money: 2200.00, totalMoney: 26000.00, status: '冻结中', freezeReason: '订单确认' },
  { freezeDate: '2025-05-15 14:55:00', money: 3800.00, totalMoney: 30000.00, status: '异常', freezeReason: '订单退款' },
  { freezeDate: '2025-05-16 09:20:00', money: 1900.00, totalMoney: 23000.00, status: '冻结中', freezeReason: '订单确认' },
  { freezeDate: '2025-05-17 11:30:00', money: 3200.00, totalMoney: 29000.00, status: '已解冻', freezeReason: '订单退款' },
  { freezeDate: '2025-05-18 16:10:00', money: 4100.00, totalMoney: 34000.00, status: '异常', freezeReason: '订单确认' },
  { freezeDate: '2025-05-19 07:45:00', money: 2600.00, totalMoney: 27000.00, status: '冻结中', freezeReason: '订单退款' },
  { freezeDate: '2025-05-20 15:20:00', money: 4900.00, totalMoney: 36000.00, status: '已解冻', freezeReason: '订单退款' }
]

export default [
  {
    url: '/mock/freezelog/list',
    method: 'get',
    timeout,
    response: ({ query }) => {
      const { pageIndex = 1, pageSize = 10, startTime, endTime, source } = query

      let filteredList = freezeLogList

      if (startTime) {
        filteredList = filteredList.filter(item => new Date(item.freezeDate) >= new Date(startTime))
      }
      if (endTime) {
        filteredList = filteredList.filter(item => new Date(item.freezeDate) <= new Date(endTime))
      }

      if (source) {
        if (source === '订单确认') {
          filteredList = filteredList.filter(item => item.freezeReason === '订单确认')
        } else if (source === '订单退款') {
          filteredList = filteredList.filter(item => item.freezeReason === '订单退款')
        }
      }

      const start = (pageIndex - 1) * pageSize
      const end = start + Number(pageSize)

      return {
        code: SUCCESS_CODE,
        data: {
          list: filteredList.slice(start, end),
          total: filteredList.length
        }
      }
    }
  }
] as MockMethod[]
